import React from "react";
import { Link } from "react-router-dom";
import {
    Typography,
    Grid,
    Card,
    CardActionArea,
    CardContent,
} from "@mui/material";
import SEO from "../../components/SEO/SEO";
import PageHero from "../../components/PageHero/PageHero";
import AppDownloadCTA, {
    PageShell,
} from "../../components/AppDownloadCTA/AppDownloadCTA";
import { pageMeta } from "../../seo/pageMeta";
import { blogs } from "./blogsData";
import { SITE_URL } from "../../seo/constants";

export default function BlogsList() {
    const meta = pageMeta.blogs;
    const entries = Object.entries(blogs);

    return (
        <PageShell maxWidth="lg">
            <SEO
                {...meta}
                jsonLd={{
                    "@context": "https://schema.org",
                    "@type": "CollectionPage",
                    name: meta.title,
                    description: meta.description,
                    url: `${SITE_URL}/blogs`,
                    hasPart: entries.map(([slug, blog]) => ({
                        "@type": "Article",
                        headline: blog.title,
                        description: blog.description,
                        url: `${SITE_URL}/blogs/${slug}`,
                    })),
                }}
            />

            <PageHero
                eyebrow="Islamic Learning Hub"
                title="Islamic Blogs — Quran, Salah, Dua & Deen"
                subtitle="Clear, beginner-friendly guides for Muslims: learn about Allah, the Holy Quran, Prophet Muhammad ﷺ, how to pray Salah, dua, Ramadan, Tawhid, and how to become Muslim."
                breadcrumbs={[
                    { label: "Home", to: "/" },
                    { label: "Islamic Blogs" },
                ]}
            />

            <Grid container spacing={3}>
                {entries.map(([slug, blog]) => (
                    <Grid item xs={12} sm={6} md={4} key={slug}>
                        <Card sx={{ height: "100%" }}>
                            <CardActionArea
                                component={Link}
                                to={`/blogs/${slug}`}
                                sx={{ height: "100%", alignItems: "stretch" }}
                            >
                                <CardContent sx={{ p: 3 }}>
                                    <Typography
                                        variant="overline"
                                        sx={{ color: "primary.main", fontWeight: 700 }}
                                    >
                                        Islamic Guide
                                    </Typography>
                                    <Typography
                                        variant="h6"
                                        component="h2"
                                        sx={{
                                            mb: 1.5,
                                            fontWeight: 600,
                                            lineHeight: 1.35,
                                            color: "text.primary",
                                        }}
                                    >
                                        {blog.title}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: "text.secondary",
                                            lineHeight: 1.65,
                                            display: "-webkit-box",
                                            WebkitLineClamp: 4,
                                            WebkitBoxOrient: "vertical",
                                            overflow: "hidden",
                                        }}
                                    >
                                        {blog.description}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            mt: 2,
                                            color: "primary.main",
                                            fontWeight: 600,
                                        }}
                                    >
                                        Read guide →
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            <AppDownloadCTA
                title="Learn Islam in the app too"
                subtitle="Pair these Islamic blogs with Quran Chat Buddy — AI Quran chat, Salah prayer times, daily ayat, and tools to grow your deen."
            />
        </PageShell>
    );
}
